import {
  ID_COLLECT_VOYAGE,
  ID_DELIVERY_VOYAGE,
  ID_FINAL_DESTINATION_VOYAGE,
} from "views/ProcessDetails/utils/constants";

//Aqui podia fazer esse tipo usando um Record das voyages
type FieldVisibility = {
  typeVoyage: {
    visible: boolean;
    size?: number;
  };
  origin: {
    visible: boolean;
    size?: number;
  };
  destination: {
    visible: boolean;
    size?: number;
  };
  vessel: {
    visible: boolean;
    size?: number;
  };
  voyageFlight: {
    visible: boolean;
    size?: number;
  };
  etd: {
    visible: boolean;
    size?: number;
  };
  eta: {
    visible: boolean;
    size?: number;
  };
  cargoLoad: {
    visible: boolean;
    size?: number;
  };
  cargoUnload: {
    visible: boolean;
    size?: number;
  };
  placePickup: {
    visible: boolean;
    size?: number;
  };
  placeDelivery: {
    visible: boolean;
    size?: number;
  };
  typeService: {
    visible: boolean;
    size?: number;
  };
  bindingDate: {
    visible: boolean;
    size?: number;
  };
  grantDate: {
    visible: boolean;
    size?: number;
  };
  transportCompany: {
    visible: boolean;
    size?: number;
  };
  observation: {
    visible: boolean;
    size?: number;
  };
};

export const useVoyageFieldVisibility = (isAiProcess: boolean = false) => {
  // Campos sempre visíveis
  const base: FieldVisibility = {
    typeVoyage: {
      visible: true,
      size: 3,
    },
    origin: {
      visible: true,
      size: 3,
    },
    destination: {
      visible: true,
      size: 3,
    },
    placePickup: {
      visible: false,
      size: 3,
    },
    placeDelivery: {
      visible: false,
      size: 3,
    },
    etd: {
      visible: true,
      size: 3,
    },
    eta: {
      visible: true,
      size: 3,
    },
    cargoLoad: {
      visible: true,
      size: 3,
    },
    cargoUnload: {
      visible: true,
      size: 3,
    },
    vessel: {
      visible: !isAiProcess,
      size: 3,
    },
    voyageFlight: {
      visible: !isAiProcess,
      size: 3,
    },
    typeService: {
      visible: true,
      size: 3,
    },
    bindingDate: {
      visible: false,
      size: 3,
    },
    grantDate: {
      visible: false,
      size: 3,
    },
    transportCompany: {
      visible: false,
      size: 3,
    },
    observation: {
      visible: false,
      size: 3,
    },
  };

  // Campos condicionais baseados no tipo

  const getFieldsVisibility = (
    typeVoyageId: number | null | undefined,
  ): FieldVisibility => {
    if (!typeVoyageId) {
      return base;
    }

    if (typeVoyageId === ID_COLLECT_VOYAGE) {
      return {
        ...base,
        placePickup: {
          visible: true,
          size: 3,
        },
        vessel: {
          visible: false,
          size: 3,
        },
      };
    }

    if (typeVoyageId === ID_DELIVERY_VOYAGE) {
      return {
        ...base,
        placeDelivery: {
          visible: true,
          size: 3,
        },
        vessel: {
          visible: false,
          size: 3,
        },
      };
    }

    if (typeVoyageId === ID_FINAL_DESTINATION_VOYAGE) {
      return {
        ...base,
        placeDelivery: {
          visible: true,
          size: 3,
        },
        vessel: {
          visible: false,
          size: 3,
        },
        bindingDate: {
          visible: true,
          size: 3,
        },
        grantDate: {
          visible: true,
          size: 3,
        },
        transportCompany: {
          visible: isAiProcess,
          size: 3,
        },
        observation: {
          visible: true,
          size: 3,
        },
      };
    }

    // Default (outros tipos)
    return {
      ...base,
    };
  };

  return {getFieldsVisibility};
};
